<div *ngIf="invoiceHeader">
  <div uni-flex-row class="h1 mt-1">
    <span style="flex: auto">Unitec Distribution Systems</span>
    <span>Invoice
      <span *ngIf="isPosted && !isManifested" class="h1" style="font-style: italic; color: gray">REPRINT</span>
      <span *ngIf="isManifested" class="h1" style="font-style: italic; color: gray">ON MANIFEST</span>
    </span>
  </div>
  <div uni-flex-row class="mt-1">
    <span style="flex: auto; font-style: italic">Innovative Apparel Distribution Systems<br />Tax Id: 52-0551098</span>
    <span style="font-size: 1.25rem; font-style: italic;">{{invoiceHeader.joHeader.account.accountName}}</span>
  </div>

  <div uni-flex-row class="mt-3 align-items-start">
    <uni-field uni-flex-item label="Bill">
      <textarea pInputText rows="5" [ngModel]="getBillingAddress()" readonly="readonly"></textarea>
    </uni-field>
    <uni-field uni-flex-item label="Ship">
      <textarea pInputText rows="5" [ngModel]="getAddress(invoiceHeader.joHeader, 'shipping')"
        readonly="readonly"></textarea>
    </uni-field>
  </div>

  <div uni-flex-row class="mt-3 mb-3 justify-between">
    <uni-field style="width: 20%" label="Invoice #">
      <input pInputText [ngModel]="invoiceHeader.id" readonly="readonly" />
    </uni-field>
    <uni-field style="width: 15%" label="Invoice Date">
      <input pInputText [ngModel]="invoiceHeader.invoiceDate | date : 'MM/dd/yyyy'" readonly="readonly" />
    </uni-field>
    <uni-field style="width: 15%" label="Due Date">
      <input pInputText [ngModel]="invoiceHeader.dueDate | date : 'MM/dd/yyyy'" readonly="readonly" />
    </uni-field>
    <uni-field style="width: 28%" label="Your PO Number">
      <input pInputText [ngModel]="invoiceHeader.joHeader?.customerPurchaseOrderNumber" readonly="readonly" />
    </uni-field>
    <uni-field style="width: 15%" label="Amount Due" labelClass="flex-1 text-right">
      <input pInputText [ngModel]="totalAmtOrZero | currency" readonly="readonly" style="text-align: right" />
    </uni-field>
  </div>

  <table class="grid-print">
    <thead>
      <tr>
        <th>Manufacturer</th>
        <th>Description</th>
        <th>Catalog</th>
        <th>Features</th>
        <th class="th-shade col-center line-left">Type</th>
        <th class="th-shade col-right">Qty</th>
        <th class="th-shade col-right">Amt/Unit</th>
        <th class="th-shade col-right line-right">Oversize</th>
        <th class="col-right">Total</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let d of flatLegs">
        <tr>
          <td>{{ d.mfr }}</td>
          <td>{{ d.desc }}</td>
          <td>{{ d.ptConfigName }}</td>
          <td>{{ d.featureChoicesExtract }}</td>
          <td class="col-center">{{ d.legLabel }}</td>
          <td class="col-right">{{ d.qty }}</td>
          <td class="col-right">{{ d.unitAmt }}</td>
          <td class="col-right">{{ d.unitOs }}</td>
          <td class="col-right">{{ d.total }}</td>
        </tr>
        <tr *ngFor="let m of d.embs">
          <td></td>
          <td class="td-shade">{{ m.description }}</td>
          <td class="td-shade">{{ m.additionalInfo }}</td>
          <td class="td-shade"></td>
          <td class="td-shade"></td>
          <td class="td-shade col-right">{{ m.qty }}</td>
          <td class="td-shade col-right">{{ m.unitPrice }}</td>
          <td class="td-shade"></td>
          <td class="col-right td-shade">{{ m.total }}</td>
        </tr>
      </ng-container>
      <!-- <tr class="bottom-row">
            <td colspan="4"></td>
            <td class="col-right">{{ invoiceHeader.calcExtendedQty() }}</td>
            <td colspan="3"></td>
            <td class="col-right">{{ invoiceHeader.calcExtendedReissueQty() }}</td>
            <td></td>
            <td class="col-right">{{ invoiceHeader.calcExtendedAmt() + invoiceHeader.calcExtendedReissueAmt() | currency}}</td>
          </tr> -->
    </tbody>
  </table>

  <div uni-flex-row class="mt-3">
    <div style="width: 62%">
      <div class="my-2">
        <uni-field style="width: 90%" label="Employee">
          <input pInputText [ngModel]="employee" readonly="readonly" />
        </uni-field>
      </div>
      <div class="my-2">
        <uni-field style="width: 90%" label="Program">
          <input pInputText [ngModel]="programName" readonly="readonly" title="Program" />
        </uni-field>
      </div>
      <div class="my-2">
        <uni-field style="width: 90%" label="Program User Group">
          <input pInputText [ngModel]="programUserGroupName" readonly="readonly" title="Program User Group" />
        </uni-field>
      </div>
      <div class="my-2">
        <uni-field style="width: 90%" label="Freight">
          <textarea pInputText [ngModel]="invoiceHeader.shipFreightInfo" rows="4" cols="80"
            readonly="readonly" title="Freight"></textarea>
        </uni-field>
      </div>
      <div class="my-2">
        <uni-field style="width: 90%" label="Shipped Via / Shipping Id">
          <input pInputText [ngModel]="shippedViaAndShippingId" readonly="readonly" title="Shipped Via / Shipping Id" />
        </uni-field>
      </div>
      <div class="my-2">
        <uni-field style="width: 90%" label="Tax Exempt #">
          <input pInputText [ngModel]="invoiceHeader.joHeader.account.accountTaxExemptionNumber" readonly="readonly" title="Tax Exempt #" />
        </uni-field>
      </div>
    </div>
    <div style="
        width: 35%;
        padding: 1.5rem;
        border: 1px solid black;
        align-self: center;
        break-inside: avoid;
      " class="grid-summary">
      <div class="row" *ngIf="hasReissue">
        <div>Subtotal New:</div>
        <div>{{ invoiceHeader.calcExtendedAmt() || 0 | currency }}</div>
      </div>
      <div class="row" *ngIf="hasReissue">
        <div>Subtotal Reissue:</div>
        <div>{{ invoiceHeader.calcExtendedReissueAmt() || 0 | currency }}</div>
      </div>
      <div class="row">
        <div>Subtotal:</div>
        <div>{{ subtotalAmt | currency }}</div>
      </div>
      <div class="row">
        <div>Tax:</div>
        <div>{{ invoiceHeader.taxAmt || 0 | currency }}</div>
      </div>
      <div class="row">
        <div>Handling:</div>
        <div>{{ invoiceHeader.orderHandlingAmt || 0 | currency }}</div>
      </div>
      <div class="row">
        <div>Freight:</div>
        <div>{{ invoiceHeader.calcShipFreightAmt() | currency }}</div>
      </div>
      <div class="row">
        <div>Prepaid:</div>
        <div style="margin-right: -4px">
          ({{ invoiceHeader.prepaymentAmt || 0 | currency }})
        </div>
      </div>
      <div class="row" *ngIf="invoiceHeader.joHeader.pCardPaymentProfileId">
        <div>{{ paymentName }}:</div>
        <div style="margin-right: -4px">
          ({{ invoiceHeader.pCardAmt || 0 | currency }})
        </div>
      </div>
      <div class="row" style="font-weight: bold">
        <div>{{ amountLabel }}:</div>
        <div>{{ totalAmtAbs | currency }}</div>
      </div>
      <div *ngIf="invoiceHeader.roundedTotalAmt() < 0" class="row" style="margin-top: 10px">
        Unused portion of prepayment {{ totalAmtAbs | currency }} will be
        applied to future shipments on this order.
      </div>
    </div>
  </div>
</div>